import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { UrlCaptureGuard } from './modules/utils/urlCaptureGuard.service';
import { AuthCookieGuard } from './interceptors/auth-cookie_guard.service';
// prettier-ignore
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboards/project'
    {path: '', pathMatch : 'full', redirectTo: 'home'},

    // Redirect signed-in user to the '/dashboards/project'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {
        path: 'Auth',  // Also handle just "Auth" without trailing segments
        redirectTo: 'auth'
    },
    
    {
        path: 'auth/login/:authId', 
        canActivate: [UrlCaptureGuard],
        loadChildren: () => import('app/modules/landing/home/home.routes')
    },
    {
        path: 'auth/activate/:activateCode',
        canActivate: [UrlCaptureGuard],
        loadChildren: () => import('app/modules/landing/home/home.routes')
    },
    {
        path: 'auth/remember/:authId',
        canActivate: [UrlCaptureGuard],
        loadChildren: () => import('app/modules/landing/home/home.routes')
    },
    {
        path: 'auth/rememberPassword/:authId',
        canActivate: [UrlCaptureGuard],
        loadChildren: () => import('app/modules/landing/home/home.routes')
    },
    {
        path: 'auth/signup/:authId',
        canActivate: [UrlCaptureGuard],
        loadChildren: () => import('app/modules/landing/home/home.routes')
    },
    {
        path: 'campaign/:id',
        canActivate: [UrlCaptureGuard],
        loadChildren: () => import('app/modules/landing/home/home.routes')
    },
    {
        path: 'signed-in-redirect',
        pathMatch : 'full',
        redirectTo: 'home'
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
           
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
          
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [

            // Dashboards
            {path: 'dashboards', children: [
               
            ]},

            // Apps
            {path: 'apps', children: [
               
            ]},

            // Pages
            {path: 'pages', children: [

               
                
            ]},

            // User Interface
            {path: 'ui', children: [

                
            ]},

            // Documentation
            {path: 'docs', children: [

               
            ]},

            // 404 & Catch all
            
            {path: '**', redirectTo: '404-not-found'}
        ]
    }
];
